import React from 'react'
import { createRoot } from 'react-dom/client'

import App from './App'

declare global {
  interface Document {
    azureLoginCreate?: () => void
  }
}

if (!document.azureLoginCreate) {
  document.azureLoginCreate = function () {
    createRoot(document.getElementById('azure-login-root') as HTMLElement).render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    )
  }
}

if (window.location.hostname === 'localhost' || window.location.hostname.includes('azure-login')) {
  createRoot(document.getElementById('azure-login-root') as HTMLElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  )
}
